<template lang="">
<table class="styled-table">
  <thead>
    <tr>
      <th scope="col">{{ $t("fuelType") }}</th>
      <th scope="col">{{ $t("fuelConsumption") }} <strong>(t)</strong></th>
      <th scope="col"><ButtonPrime @click="addFuel()" id="add-button">+</ButtonPrime></th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(fuel, index) in this.arrayFuel" :key="index">
     <td>
       <DropdownPrime
            id="state"
            v-model="fuel.fuel"
            :options="fuelTypes"
            optionLabel="name"
            class="input-style"
        />
     </td>
     <td>
      <input class="input-style" v-model="fuel.consumption" type="number" />
     </td>
     <td>
        <ButtonPrime @click="eliminateFuel(index)" id="add-button">-</ButtonPrime>
     </td>
    </tr>
  </tbody>
</table>
</template>

<script>

import FuelTypeService from "@/services/FuelTypeService";

export default {

    data(){
     return{
        arrayFuel : [],
        fuelTypes: [],
        arrayFuelAux: []
     }
    },

    props:{
        fuelArray : Array
    }, 

    created() {

      //obtenemos los tipos de combustible
      this.fuelTypeService = FuelTypeService.getInstance()
      this.fuelTypeService.getTypes(this.fuelTypes);
      
      for(var i =0; i< this.fuelArray.length; i++){
        //console.log("Fuel Array " + this.fuelArray[i].fuel.id)
        this.arrayFuelAux.push(this.fuelArray[i])
        //console.log("Intentamos añadir un elemento en inicio " + this.arrayFuelAux[i].fuel.id)
        //this.addFuelStart(this.arrayFuelAux[i].fuel.name, this.arrayFuelAux[i].consumption)
      }
    },

    mounted() {
      setTimeout(() => { 
        this.arrayFuelAux.forEach( (fuel) => {
          //console.log("Array Fuel Aux " + fuel.fuel.id)
          this.addFuelStart(fuel.fuel.name, fuel.fuel.id, fuel.consumption)
        })
      }, 500)
    },

    watch:{
      arrayFuel:{
        handler(newVal){
          //console.log("Variable antigua: " + oldVal)

          this.$emit('obtener-lista-fuel', newVal)
        },
        deep: true
      }
    },

    methods:{

     addFuel(){
        //console.log("Añadimos un elemento");
        //añadimos un combustible vacío para que se pueda rellenar
        this.arrayFuel.push({name: " ", consumption: 0})
     },

     addFuelStart(fuelName, fuelId, consumptionCuantity){
        //console.log("Añadimos un elemento en inicio " + fuelId)
        this.arrayFuel.push({ fuel: {id: fuelId, name: fuelName}, consumption: consumptionCuantity})
        //console.log(this.arrayFuel[0].fuel.id)
     },

     eliminateFuel(index){

        //console.log("Eliminamos un elemento");
        //eliminamos el elemento de la posición 'index'
        this.arrayFuel.splice(index, 1);
     },

     //Función de prueba para ver que se ha copiado bien los combustibles
     listFuel(){
      for(var i =0; i< this.arrayFuel.length; i++){
        console.log("Fuel: " + this.arrayFuel[i].fuel.name + " - Consumption: " + this.arrayFuel[i].consumption)
      }
     }
    }

}
</script>

<style scoped>
.styled-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  margin: 20px 0;
}

.styled-table th,
.styled-table td {
  padding: 16px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.styled-table th {
  background-color: #f2f2f2;
}

.styled-table tbody tr:last-child td {
  border-bottom: none;
}

.styled-table tbody tr:hover {
  background-color: #f5f5f5;
}

button {
  margin-top: 10px;
  padding: 8px 12px;
  background-color: #337AFF;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #2659b9;
}

.input-style{
    border-radius: 5px;
    height: 40px;
    width: 250px;
}

</style>